import { middlewareController } from '../middlewareController'

const BASE_URL = process.env.REACT_APP_PRODUCT_UPDATES_API_ENDPOINT

export const productUpdatesApi = middlewareController.create.axiosInstance({
  baseURL: BASE_URL
})

export * from './requests'
